import { render } from "./IndustryCover2.vue?vue&type=template&id=7d5a25af"
import script from "./IndustryCover2.vue?vue&type=script&lang=js"
export * from "./IndustryCover2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rnedkov/Documents/GitHub/cleaner-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__